( function( global, $ ) {
    "use strict";

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container),
            $formExpander = $container.find('[gr-form-expander]'),
            $formExpanderTrigger = $container.find('[gr-form-expander-trigger]'),
            $formExpanderReset = $container.find('[gr-form-expander-reset]'),
            $formExpanderSummary = $container.find('[gr-form-summary-filters]'),
            $formInputs = $container.find('[gr-form-expander] :input'),
            $form = $formExpander.find('form');

        //Handle open / close
        $formExpanderTrigger.on('click.formexpander', function(event) {
            event.preventDefault();
            $formExpander.toggleClass('is-open');
        });

        //Handle ready / not ready
        $formExpanderReset.on('click.formexpander', function(event) {
            event.preventDefault();
            $formExpander.removeClass('is-ready');

            //Reset value of inputs
            $formInputs.not('[name^="_"]').val('');
            $formInputs.filter('[name="search_bookings[order]"]').val('created_date_desc');

            //Reset value of selectize
            var $selectizeFormInputs = $formExpander.find('.selectized:input');
            for (var i = 0; i < $selectizeFormInputs.length; i++) {
                $selectizeFormInputs.get(i).selectize.clear();
            }

            $form.trigger('submit');
        });

        $form.on('change.formexpander', function () {
            $formExpander.addClass('is-ready');
        });

        $form.on('submit.formexpander', function () {
            $formExpander.removeClass('is-open');
            $formExpanderSummary.addClass('ghost');
        });
    });

}( window.groots, jQuery ));
